<label>{{ config.label }} {{ config.isRequired ? '*' : '' }}</label>
<mat-chip-listbox>
  <mat-chip-option
    color="primary"
    (click)="onToggle(1)"
    [selected]="config.firstChip.selected"
    [disabled]="config.firstChip.disable"
  >
    {{ config.firstChip.value }}
  </mat-chip-option>
  <mat-chip-option
    color="primary"
    (click)="onToggle(2)"
    [selected]="config.secondChip.selected"
    [disabled]="config.secondChip.disable"
  >
    {{ config.secondChip.value }}
  </mat-chip-option>
</mat-chip-listbox>
